import BaseProduct from '../domains/Product/BaseProduct'
import Bundle from '../domains/Product/BundleProduct'
import { ProductVariantOption } from '../domains/ProductVariant'
import { getIsSelectedColorAppExclusive } from '../helpers/productHelper'

import { getFestivalOfferPrice, getIsFinalSaleProduct } from './festivalOffersUtility'

export interface FinalSaleEventProperties {
  is_final_sale: number
  is_app_exclusive: number
  promo_price: number | string | undefined
}

export const getFinalSaleEventProperties = (product: BaseProduct | Bundle, selectedOptions: ProductVariantOption[]) => {
  const promo_price = getFestivalOfferPrice({ product, selectedOptions })
  const is_final_sale = getIsFinalSaleProduct(product, selectedOptions)
  const is_app_exclusive = getIsSelectedColorAppExclusive(product.productOptions, selectedOptions)
  return {
    is_final_sale: is_final_sale ? 1 : 0,
    is_app_exclusive: is_app_exclusive ? 1 : 0,
    promo_price: promo_price ?? undefined,
  }
}
